import { ErrorPage, Loader, useGetCreditApplicationById } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useGetIdentityVerificationSession } from '../../api/identity-verification-session-api'
import { FailedIdentificationFinalPage } from './FailedIdentificationPage'
import VouchedComponent from './VouchedComponent'

const VouchedPage = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [session, isLoadingIdentityVerif] = useGetIdentityVerificationSession(id!)
  const [creditApp, isLoadingCreditApp] = useGetCreditApplicationById(id!, EFinancingProgram.B2c)

  if (isLoadingIdentityVerif || isLoadingCreditApp)
    return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />
  if (!creditApp) return <ErrorPage />
  const vouchedFailedCount = creditApp.applicant?.vouchedFailedCount || 0
  if (vouchedFailedCount > 1) return <FailedIdentificationFinalPage creditApp={creditApp} />

  return <VouchedComponent session={session} creditApplication={creditApp} />
}

export default VouchedPage
